import React from 'react';

import Icon from '../Icon/Icon';

const DeviceUnregisterIcon = (props) => {
    return (
        <Icon width='24' height='24' fill='none' {...props}>
            <path
                d='M6.25049 20.3828C6.11242 20.3828 6.00049 20.2709 6.00049 20.1328L6.00049 6.6748C6.00049 6.53673 6.11242 6.4248 6.25049 6.4248H8.93213C9.64918 6.4249 10.2269 7.00234 10.2271 7.71582L10.2271 18.4736C10.2271 19.2399 10.5015 19.8837 10.8286 20.3828H6.25049Z'
                stroke='#F6F4F0'
                strokeWidth='1.5'
            />
            <path
                d='M15.9546 20.3828H12.2729C11.3065 20.3828 10.5229 19.5993 10.5229 18.6328L10.5229 4.25C10.5229 3.83579 10.8587 3.5 11.2729 3.5H14.9546C16.1972 3.5 17.2046 4.50736 17.2046 5.75L17.2046 19.1328C17.2046 19.8232 16.6449 20.3828 15.9546 20.3828Z'
                stroke='#F6F4F0'
                strokeWidth='1.5'
                strokeLinejoin='round'
            />
        </Icon>
    );
};

export default DeviceUnregisterIcon;
